module.exports = __webpack_public_path__ + "img/why.910750f8.svg";